export default __webpack_public_path__ + "static/JMC-logo-color-22ea21445aaea0272e23af77e8278b74.svg";